import React, { useEffect, useState } from "react";
import welcomeImage from "../../assests/images/welcome-right-img.png";
import { useNavigate } from "react-router-dom";
import AlertComponent from "../alert/alert";

function WelcomeDashboard() {
  let navigate = useNavigate();

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const handleButtonClick = () => {
    openAlert(true, "success", `Coming Soon.`);
  };

  const onNavigateChange = (url) => {
    navigate(url);
  };

  return (
    <div className="login-forms">
      <section className="welcome_outer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="welcome_style pad_left">
                Welcome to Avaada
                <div className="lets_style">Let's get started! </div>
                <div className="lets_style_2">You are successfully onboarded. </div>
              </div>

              {/* <div className="initiate-btn">
                <button
                  onClick={() => onNavigateChange(`/admin/onboarding-from`)}
                >
                  Initiate your Onboarding Process
                </button>
              </div> */}
              {/* <div class="participate-btn">
                <button
                  onClick={() => {
                    handleButtonClick();
                  }}
                >
                  Participate in Bidding
                </button>
              </div> */}
            </div>
            <div className="col-md-6">
              <img src={welcomeImage} alt="" className="welcome-img-1" />
            </div>
          </div>
        </div>
        <AlertComponent
          alertComponent={alertComponent}
          handleClose={handleCloseAlert}
        />
      </section>
    </div>
  );
}

export default WelcomeDashboard;
